import { features } from 'config/profile'

export const IS_PASSWORD_ENABLED = features.LOGIN_METHOD !== 'MAGICLINK'
